import { createContext, useContext } from 'react';
import { RouteV2Id } from './routesConfigV2';

export const PathContext = createContext<RouteV2Id[]>([]);

function usePathContext(): RouteV2Id[] {
  return useContext(PathContext);
}

export default usePathContext;
